import React, { useEffect } from 'react';

import { Container } from '../../../../../symphony';

import { SlLEContext } from '../../../global-constants';
import {
  ActionType,
  IMaterialProps,
  RequestType,
} from '../../../global-interface';
import { SlActions } from '../../../services/ActionsService/sl-actions';
import { SlTIYWidgetPlayground } from '../../../../../lePlayground/public/SlTIYWidgetPlayground/SlTIYWidgetPlayground';
import { IMaterialStatus } from '../../../../../api/private/learn-engine-api/learn-engine-api.interface';
import { ErrorCodes } from '../../../../../api/private/global.interface';
import { SlDataService } from '../../../services/sl-data.service';
import { useContainerData } from '../../../../../shared/public/SlHooks/useContainerData';

export function TIY({ materialInfo }: IMaterialProps): JSX.Element {
  const { actions$ } = Container.take(SlLEContext, SlActions);

  const { alias$: alias, lessonSessionGuId$: lessonSessionGuId } = useContainerData(SlLEContext, SlDataService, ['alias$', 'lessonSessionGuId$']);

  const solveMaterialCallback = (statusChanges: IMaterialStatus[]): void => {
    actions$.next({
      type: ActionType.UpdateStatuses,
      requestType: RequestType.Parallel,
      data: {
        statusChanges,
      },
    });
  };

  const onSessionError = () => {
    actions$.next({
      type: ActionType.ExpiredSessionIdError,
      requestType: RequestType.Parallel,
    });
  };

  useEffect(() => {
    actions$.next({
      type: ActionType.OnTIYWidgetMount,
      requestType: RequestType.Parallel,
    });
  }, []);

  return (
    <SlTIYWidgetPlayground
      errorHandler={{ [ErrorCodes.ExpiredSession]: onSessionError }}
      lessonSessionGuId={lessonSessionGuId}
      courseAlias={alias}
      soloLearnUrl={Container.take(SlLEContext, 'soloLearnUrl')}
      solveMaterialCallback={solveMaterialCallback}
      materialInfo={materialInfo}
    />
  );
}
